import * as React from "react";
import PropTypes from "prop-types";

const ChevronLeft = ({
  alt = "Chevron Left",
  className = "",
  size = 24
}) => (
  <svg
    aria-label={alt}
    className={`chevron ${className}`}
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    role="img"
    viewBox="0 0 24 24"
  >
    <title id="ChevronLeft">{alt}</title>
    <path
      fill="#241C15"
      fillRule="evenodd"
      d="m13.293 6.293 1.414 1.414L10.414 12l4.293 4.293-1.414 1.414L7.586 12z"
      clipRule="evenodd"
     />
  </svg>
);

ChevronLeft.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.number,
};

export default ChevronLeft;